{"boat":"Aggiungi una barca","trip":"Aggiungi viaggio","task":"Aggiungi attività","inventory":"Aggiungi articolo di inventario","cost":"Aggiungi costo"}